import styled from '@emotion/styled';
import { getFlagEmoji } from '@racemap/utilities/functions/getFlagEmoji';
import { getMccMnc } from '@racemap/utilities/functions/getMccMnc';
import { Tooltip, Typography } from 'antd';
import type { FC } from 'react';
import { useCarrierInformation } from 'src/lib/customHooks';

export type Props = {
  networkOperators: Array<string>;
};

const { Text } = Typography;

export const NetworkOperator: FC<Props> = ({ networkOperators }) => {
  return (
    <div>
      {networkOperators.map((operator) => {
        const { mcc, mnc } = getMccMnc(operator);

        const { carrierInformation, isLoading } = useCarrierInformation({ mcc, mnc });

        if (isLoading) return <div>Loading...</div>;

        return (
          <Operator key={`${operator}`}>
            <MccMnc>
              <div>{`MCC: ${mcc}`}</div>
              <div>{`MNC: ${mnc}`}</div>
            </MccMnc>
            {carrierInformation ? (
              <>
                <CarrierName ellipsis={true}>{carrierInformation.carrier_name}</CarrierName>
                <Tooltip title={carrierInformation.country_name}>
                  {getFlagEmoji(carrierInformation.country ?? null)}
                </Tooltip>
              </>
            ) : (
              <div>Carrier information not available</div>
            )}
          </Operator>
        );
      })}
    </div>
  );
};

const Operator = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  gap: 1rem;
`;

const MccMnc = styled.div`
  display: flex;
  gap: 0.5rem;
  width: 145px;
`;

const CarrierName = styled(Text)`
  width: 150px;
`;
